import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const ClientNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='client' />

export default ClientNavItem